module.exports = __webpack_public_path__ + "static/img/advertisement2.6d01c732.png";